import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import MaintenancePage from "./pages/MaintenancePage";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

const isMaintenanceMode =
  process.env.REACT_APP_MAINTENANCE_MODE === "true";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (isMaintenanceMode) {
  root.render(
    <React.StrictMode>
      <MaintenancePage />
    </React.StrictMode>
  );
} else {
  root.render(
    <GoogleOAuthProvider clientId="776928621665-dqpo55nlg09kp91prurcshvca5jsq8po.apps.googleusercontent.com">
      <React.StrictMode>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </React.StrictMode>
    </GoogleOAuthProvider>
  );
}
